import React from 'react';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import { PageNotFoundView } from '../../../views';
import { OwnerManualProps } from '../owner-manual/hook/use-owner-manual-content';

interface OwnerManualLoadingProps {
    ownerManualContent: OwnerManualProps | null;
    loading: boolean;
}
export const OwnerManualLoading = (props: OwnerManualLoadingProps) => {
    return props.ownerManualContent && props.loading ? (
        <>
            <ActivityIndicator />
        </>
    ) : (
        <>
            <PageNotFoundView />
        </>
    );
};
